import React from 'react';
import { Gradient, gradientName } from '../Gradient';
import { nanoid } from 'nanoid';

export type Props = {
  /**
   * Size of the icon in px, em, etc.
   */
  size: string;
  /*
   * Color of the icon as a hexadecimal.
   */
  color: string;
  /*
   * If true, the color will be a linear gradient, otherwise, it will use the
   * provided color.
   */
  gradient?: boolean;
};

export const ArrowLeftCircle: React.FC<Props> = ({
  gradient = false,
  ...props
}: Props) => {
  const idCut = nanoid();
  const { size, color } = props;
  const fill = gradient ? gradientName : color;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <mask id={idCut}>
          <rect width="11.2696" height="11.2696" fill="white" />
          <path
            fill="black"
            d="M4.68966 5.85775L7.09724 8.26533C7.32696 8.49506 7.32696 8.86751 7.09724 9.09723C6.86752 9.32695 6.49507 9.32695 6.26535 9.09723L3.44182 6.27369C3.2121 6.04397 3.2121 5.67152 3.44182 5.4418L6.26535 2.61827C6.49507 2.38855 6.86752 2.38855 7.09724 2.61827C7.32696 2.84799 7.32696 3.22044 7.09724 3.45017L4.68966 5.85775Z"
          />
        </mask>
      </defs>
      <rect
        mask={`url(#${idCut})`}
        width="11.2696"
        height="11.2696"
        rx="5.63478"
        fill={fill}
      />
      <defs>{gradient && <Gradient />}</defs>
    </svg>
  );
};
